import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';

import {UserdialogComponent} from 'src/app/common/userdialog/userdialog.component';
import { AppserviceService } from 'src/app/appservice.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as myGlobal from 'src/app/globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent implements OnInit{
  title = 'Parts Portal';
  username:string;
  showclose:boolean = false;
  userdetails = "";
  adminBool:boolean = false;
  appform:any;
  _user:string = '';
  _authorization:string = '';
  _admin:string = '';
  _component:string = '';

  appCompModel = {
    'search':''
  };

  public adminUserBool:boolean =false;
  constructor(private _formBuilder: FormBuilder, private AppService: AppserviceService,private route: ActivatedRoute,private router: Router, private modalService:NgbModal){
    console.log(window.location.pathname);
    console.log(location.origin);
    this.router.navigate(['']);
    const url = new URL(window.location.href);
    if (url.searchParams.has('username')) {
      // tslint:disable-next-line:prefer-const variable-name
          const _userDetails = window.location.href.split('?')[1].split('&');
          console.log(_userDetails);
          _userDetails.forEach((userDetail: string) => {
            localStorage.setItem(userDetail.split('=')[0], userDetail.split('=')[1]);
          });
    }
    this._component = '/home';
  }

  logOut(){
    this.router.navigate(['']);
    localStorage.clear();
    this.appSetUp();
  }

  appSetUp(){
    if (localStorage.getItem('username') && localStorage.getItem('authorization')) {
      this.adminBool = (this._admin === '1')? true:false;
      this.username = this._user;
      this.router.navigate([this._component]);
    } else {
      if (!localStorage.getItem('username') && !localStorage.getItem('authorization')) {
        this.modalService.open(UserdialogComponent, {
          size: 'sm',
          centered: true,
          backdrop: 'static'
        });
        this.setHeader();
      } else {
        this.username = localStorage.getItem('username');
        this.adminBool = (localStorage.getItem('admin') === '1') ? true : false;
        this.router.navigate(['/home']);
      }
    }
  }

  setHeader(){
    var that = this;
    var count = 0;
    var _timer = setInterval(function(){
      count += 1;
      if(that.AppService.getAdminBool()){
        that.adminBool = true;
        clearInterval(_timer);
      }
      if(count == 50)clearInterval(_timer);
    },100)
  }

  getFeRslService(){
    if(localStorage.getItem('authorization')){
      this.AppService.fetchFeEngineers().subscribe((feData) => {
        /* feData['data'] = Object.assign([], feData['data']).filter(item => {
          if(item.name !== localStorage.getItem('username')){
            return item;
          }
        }) */
        this.AppService.setEngData(feData['data']);
      });

      this.AppService.rslStores('').subscribe((rslData) => {
        this.AppService.setRslData(rslData['data']);
      });
    }
  }

  openLoginModal(){
    this.showclose = true;
    this.modalService.open(UserdialogComponent, {
      size: 'sm',
      centered: true,
      backdrop:'static'
    });
  }

  ngOnInit(){
    //console.log(myGlobal.configFile);
    this.AppService.getServiceBaseUrl(myGlobal.configFile).subscribe(
      (serviceUrl) => {
        //console.log(serviceUrl);
        if(serviceUrl != null){
          this.AppService.setBaseUrl(serviceUrl['api_url']);
        }else{
          this.AppService.setBaseUrl('http://localhost:3010/');
        }
        this.getFeRslService();
        //console.log(serviceUrl['api_url']);
        this.appSetUp();
        //this.router.navigate(['']);
      },(err) =>{
        this.AppService.setBaseUrl('http://localhost:3010/');
        this.getFeRslService();
        this.appSetUp();
        //this.router.navigate(['']);
      }
    );

    this.appform = new FormGroup({
      'search':new FormControl(this.appCompModel.search)
    });
  }
}
